import { FlexBox, LoadingButton } from '@dfl/mui-react-common';
import DownloadIcon from '@mui/icons-material/Download';
import { CircularProgress, IconButton, SxProps, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick: () => void;
  isLoading?: boolean;
  iconOnly?: boolean;
  className?: string;
  text?: string;
  variant?: 'contained' | 'outlined' | 'text';
  sx?: SxProps;
};

const DownloadInvoiceButton = ({
  onClick,
  isLoading,
  iconOnly = false,
  className,
  variant = 'contained',
  text = 'common:invoiceDownload',
  sx
}: Props) => {
  const { t } = useTranslation('common');

  if (iconOnly) {
    return (
      <IconButton sx={sx} title={t(text)} onClick={onClick} color={'primary'} disabled={isLoading} className={className}>
        {isLoading ? <CircularProgress color='primary' size={16} /> : <DownloadIcon />}
      </IconButton>
    );
  }

  return (
    <LoadingButton sx={sx} variant={variant} onClick={onClick} color={'primary'} loading={isLoading} className={className}>
      <FlexBox alignItems={'center'} gap={1}>
        <DownloadIcon />
        <Typography>{t(text)}</Typography>
      </FlexBox>
    </LoadingButton>
  );
};

export default memo(DownloadInvoiceButton);
